// extracted by mini-css-extract-plugin
module.exports = {"notification-wrapper":"_2plfw","notificationWrapper":"_2plfw"};